import React from 'react';
import classnames from 'classnames';
class NoMore extends React.Component {
    render() {
        const { text, style, className } = this.props;
        return (<div className={classnames(`cfm_no_more`, className)} style={style}>
        <div className="cfm_no_more_text">{text}</div>
      </div>);
    }
}
NoMore.defaultProps = {
    style: {},
    text: 'No More',
};
export default NoMore;



// WEBPACK FOOTER //
// ./components/no-more/index.tsx